import PageTitleComponent from "../../components/PageTitle";
import Shippings from "../../components/Shipping";

export default function ShippingScreen(){
return <div>
    <PageTitleComponent title="Shipping" />
    <Shippings/>
</div>
}